import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import {
  StyledContent,
  StyledDepositContainer,
  StyledSpinnerWrapper,
} from './styles'

import { Title, Text } from '../../atoms/text'
import { Button } from '../../atoms/button'
import { Spinner } from '../../atoms/spinner'
import { DepositContent } from '../depositContent'
import { If } from '../../atoms/if'
import { useTranslation } from '../../../context/translationProvider'
import { useEventTracking } from '../../../context/eventTrackingProvider'
import { sendMobileAppEvent } from '../../../utils/mobileAppFunctionality'
import { 
  INGAME_CTA_ACTIONS,
  INGAME_DRAWERS,
} from '../../../utils/constants'
import { usePaymentDrawerContext } from '../../../context/paymentDrawerProvider'

const DepositDrawerContent = ({
  user,
  depositLobbyData,
  depositLobbyCMSData,
  usableBankAccounts,
  hasEligibleBankAccount,
  onClose,
  onSetBackUrl,
  customMargin,
  setIsDepositSecondStep,
}) => {

  const { translate } = useTranslation()
  const { trackEvent, EVENT_NAMES, EVENT_LOCATIONS, getTrackingContext } = useEventTracking()
  const addBankAccountTrackedRef = useRef(false)
  const { open: openDepositDrawer } = usePaymentDrawerContext()

  useEffect(() => {
    const isNoEligibleBankAccount = !hasEligibleBankAccount
    const hasDepositLobbyData = !!depositLobbyData
    const hasDepositLobbyCMSData = !!depositLobbyCMSData
    const hasNotBeenTracked = !addBankAccountTrackedRef.current

    const shouldTrack = isNoEligibleBankAccount && hasDepositLobbyData && hasDepositLobbyCMSData && hasNotBeenTracked
    
    if (!shouldTrack) { return }
      trackEvent(EVENT_NAMES.INGAME_DRAWER_OPENED, {
        drawer: INGAME_DRAWERS.ADD_BANK_ACCOUNT,
        site_location: EVENT_LOCATIONS.INGAME_NAVBAR,
        ...getTrackingContext(),
      }, true)
      addBankAccountTrackedRef.current = true
    
  }, [hasEligibleBankAccount, depositLobbyData, depositLobbyCMSData, trackEvent, EVENT_NAMES.INGAME_DRAWER_OPENED, getTrackingContext, EVENT_LOCATIONS.INGAME_NAVBAR])

  const handleAddBankAccountClick = () => {
    trackEvent(EVENT_NAMES.INGAME_ACTION_TAKEN, {
      drawer: INGAME_DRAWERS.ADD_BANK_ACCOUNT,
      cta: INGAME_CTA_ACTIONS.ADD_BANK_ACCOUNT,
      site_location: EVENT_LOCATIONS.INGAME_NAVBAR,
      ...getTrackingContext(),
    }, true)

    onClose()

    const handledByApp = sendMobileAppEvent('depositFromHeader')
    if (handledByApp) return

    openDepositDrawer()
    onSetBackUrl()
  }

  return (
    <StyledDepositContainer $customMargin={customMargin}>
    <If
      condition={!depositLobbyData || !depositLobbyCMSData}
      render={() => (
        <StyledSpinnerWrapper>
          <Spinner />
        </StyledSpinnerWrapper>
      )}
      renderElse={() => (
        <If
          condition={hasEligibleBankAccount}
          render={() => (
              <DepositContent
                depositClose={onClose}
                user={user}
                depositLobbyData={depositLobbyData}
                depositLobbyCMSData={depositLobbyCMSData}
                usableBankAccounts={usableBankAccounts}
                isMobile
                isInGame
                addBottomMargin
                setIsDepositSecondStep={setIsDepositSecondStep}
              />
          )}
          renderElse={() => (
            <StyledContent>
              <Title level={2}>
                {translate('game.deposit.ftd.sub-heading')}
              </Title>
              <Text level={3}>
                {translate('game.deposit.ftd.paragraph')}
              </Text>
              <Button onClick={handleAddBankAccountClick}>
                {translate('game.deposit.ftd.button-primary')}
              </Button>
            </StyledContent>
          )}
        />
      )}
    />
    </StyledDepositContainer>
  )
}

DepositDrawerContent.propTypes = {
  user: PropTypes.object.isRequired,
  depositLobbyData: PropTypes.object,
  depositLobbyCMSData: PropTypes.object,
  usableBankAccounts: PropTypes.array,
  hasEligibleBankAccount: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSetBackUrl: PropTypes.func.isRequired,
  customMargin: PropTypes.number,
}

export { DepositDrawerContent }
